export const iconFontAwesomeGamingShieldHalved = (
	<i className="fa-solid fa-shield-halved"></i>
);
